<template>
  <div class="ele-body">
    <el-card shadow="never">
      <el-form
        :model="where"
        label-width="77px"
        class="ele-form-search"
        @keyup.enter.native="reload"
        @submit.native.prevent>
        <el-row :gutter="15">
          <el-col :lg="6" :md="12">
            <el-form-item label="用户账号">
              <el-input clearable v-model.trim="where.username" placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <el-form-item label="用户昵称">
              <el-input clearable v-model.trim="where.realname" placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <el-form-item label="接入号">
              <el-input clearable v-model.trim="where.mch_id" placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <div class="ele-form-actions">
              <el-button type="primary" icon="el-icon-search" class="ele-btn-icon" @click="reload">查询</el-button>
              <el-button @click="reset">重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>

      <ele-pro-table
        ref="table"
        :where="where"
        :datasource="url"
        :columns="columns"
        :parse-data="parseData"
        :selection.sync="selection"
        :page-size="20"
        height="calc(100vh - 315px)">
        <template slot="toolbar">
          <el-button size="small" type="primary" icon="el-icon-plus" class="ele-btn-icon" @click="openEdit(null)"
            v-if="permission.includes('sys:user:add')">添加</el-button>
          <el-button size="small" type="danger" icon="el-icon-delete" class="ele-btn-icon"
            :disabled="!selection.length" @click="removeBatch"
            v-if="permission.includes('sys:user:dall')">删除</el-button>
          <el-button size="small" type="primary" icon="el-icon-circle-check" class="ele-btn-icon"
            @click="openChannelBatch(1)" v-if="permission.includes('sys:user:edit')">代收批量</el-button>
          <el-button size="small" type="primary" icon="el-icon-circle-check" class="ele-btn-icon"
            @click="openChannelBatch(2)" v-if="permission.includes('sys:user:edit')">代付批量</el-button>
        </template>

        <template slot="status" slot-scope="{ row }">
          <el-switch
            v-model="row.status"
            :disable-transitions="true"
            @change="editStatus(row)"
            :active-value="1"
            :inactive-value="2"
            v-if="permission.includes('sys:user:status')" />
        </template>
        <template slot="is_withdrawal" slot-scope="{ row }">
          <el-switch
            v-model="row.is_withdrawal"
            :disable-transitions="true"
            @change="editFlag(row, 'is_withdrawal')"
            :active-value="1"
            :inactive-value="2"
            v-if="permission.includes('sys:user:edit')" />
        </template>
        <template slot="is_exchange_center" slot-scope="{ row }">
          <el-switch
            v-model="row.is_exchange_center"
            :disable-transitions="true"
            @change="editFlag(row, 'is_exchange_center')"
            :active-value="1"
            :inactive-value="2"
            v-if="permission.includes('sys:user:edit')" />
        </template>
        <template slot="google_status" slot-scope="{ row }">
          <span
            :class="{ 'dict-cell-clickable': row.google_status == 1 }"
            @click="row.google_status == 1 && editGoogleToken(row)">
            <dict-tag dict-code="google_status" :value="row.google_status" />
          </span>
        </template>
        <template slot="action" slot-scope="{ row }">
          <el-button size="small" type="primary" class="ele-btn-icon" @click="openEdit(row)"
            v-if="permission.includes('sys:user:edit')">编辑</el-button>
          <el-button size="small" type="primary" class="ele-btn-icon" @click="openChannelUser(row, 1)"
            v-if="permission.includes('sys:user:edit')">代收</el-button>
          <el-button size="small" type="primary" class="ele-btn-icon" @click="openChannelUser(row, 2)"
            v-if="permission.includes('sys:user:edit')">代付</el-button>
          <el-dropdown class="ele-action" @command="(cmd) => onMore(cmd, row)">
            <el-button size="small" type="primary" class="ele-btn-icon">
              更多<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="test" v-if="permission.includes('sys:test:index')">测试</el-dropdown-item>
              <el-dropdown-item command="bind" v-if="permission.includes('sys:user:edit')">绑定</el-dropdown-item>
              <el-dropdown-item command="ip" v-if="permission.includes('sys:user:edit')">IP绑定</el-dropdown-item>
              <el-dropdown-item command="reset" v-if="permission.includes('sys:user:resetPwd')">重置</el-dropdown-item>
              <el-dropdown-item command="remove" divided v-if="permission.includes('sys:user:delete')">删除</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </ele-pro-table>
    </el-card>

    <user-edit :data="current" :visible.sync="showEdit" @done="reload" />
    <detail-edit :data="current" :visible.sync="detailEdit" @done="reload" />
    <channel-user-edit ref="channelUserEdit" @done="reload" />
    <channel-batch-edit ref="channelBatchEdit" @done="reload" />
    <user-test-dialog :user="testUser" :visible.sync="showTest" />
    <user-bind-dialog :user="bindUser" :visible.sync="showBind" @done="reload" />
    <user-ip-dialog :user="ipUser" :visible.sync="showIp" @done="reload" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getDictData } from '@/utils/dict';

export default {
  name: 'SystemUser',
  components: {
    UserEdit: () => import('./user-edit'),
    DetailEdit: () => import('./detail-edit.vue'),
    ChannelUserEdit: () => import('./channel-user-edit.vue'),
    ChannelBatchEdit: () => import('./channel-batch-edit.vue'),
    UserTestDialog: () => import('./user-test-dialog.vue'),
    UserBindDialog: () => import('./user-bind-dialog.vue'),
    UserIpDialog: () => import('./user-ip-dialog.vue')
  },
  computed: {
    ...mapGetters(['permission'])
  },
  data() {
    return {
      url: '/user/index',
      columns: [
        {
          columnKey: 'selection',
          type: 'selection',
          width: 45,
          align: 'center',
          fixed: 'left'
        },
        {
          prop: 'id',
          label: '序号',
          width: 60,
          align: 'center',
          showOverflowTooltip: true,
          fixed: 'left'
        },
        {
          prop: 'username',
          label: '用户账号',
          align: 'center',
          showOverflowTooltip: true,
          minWidth: 110
        },
        {
          prop: 'realname',
          label: '用户昵称',
          align: 'center',
          showOverflowTooltip: true,
          minWidth: 100,
          formatter: (row, column, cellValue) => cellValue
        },
        {
          prop: 'mobile',
          label: '手机号码',
          align: 'center',
          showOverflowTooltip: true,
          minWidth: 110,
          show: false,
          formatter: (row, column, cellValue) => cellValue
        },
        {
          prop: 'email',
          label: '电子邮箱',
          align: 'center',
          showOverflowTooltip: true,
          minWidth: 140,
          show: false,
          formatter: (row, column, cellValue) => cellValue
        },
        {
          prop: 'bot_group_id',
          label: '群组ID',
          align: 'center',
          showOverflowTooltip: true,
          minWidth: 130,
          formatter: (row, column, cellValue) => this.maskMiddle(cellValue)
        },
        {
          prop: 'google_status',
          label: '谷歌状态',
          align: 'center',
          width: 100,
          resizable: false,
          slot: 'google_status'
        },
        {
          prop: 'status',
          label: '用户状态',
          align: 'center',
          width: 100,
          resizable: false,
          slot: 'status'
        },
        {
          prop: 'is_withdrawal',
          label: '提现开关',
          align: 'center',
          width: 100,
          resizable: false,
          slot: 'is_withdrawal'
        },
        {
          prop: 'is_exchange_center',
          label: '兑换中心',
          align: 'center',
          width: 100,
          resizable: false,
          slot: 'is_exchange_center'
        },
        {
          prop: 'create_time',
          label: '创建时间',
          align: 'center',
          showOverflowTooltip: true,
          minWidth: 160,
          formatter: (row, column, cellValue) => this.$util.toDateString(cellValue)
        },
        {
          prop: 'update_time',
          label: '更新时间',
          align: 'center',
          showOverflowTooltip: true,
          minWidth: 160,
          formatter: (row, column, cellValue) => this.$util.toDateString(cellValue)
        },
        {
          columnKey: 'action',
          label: '操作',
          width: 280,
          align: 'center',
          resizable: false,
          slot: 'action',
          fixed: 'right'
        }
      ],
      where: {},
      selection: [],
      current: null,
      showEdit: false,
      detailEdit: false,
      showTest: false,
      testUser: null,
      showBind: false,
      bindUser: null,
      showIp: false,
      ipUser: null
    };
  },
  created() {
    getDictData('google_status');
  },
  methods: {
    parseData(res) {
      const rows = res && res.data;
      if (Array.isArray(rows)) {
        rows.forEach((row) => {
          row.status = Number(row.status) || 0;
          row.is_withdrawal = Number(row.is_withdrawal) || 0;
          row.is_exchange_center = Number(row.is_exchange_center) || 0;
          row.google_status = Number(row.google_status) || 0;
        });
      }
      return res;
    },
    maskMiddle(value) {
      if (value === null || value === undefined || value === '') {
        return '';
      }
      const text = String(value);
      if (text.length <= 4) {
        return text;
      }
      if (text.length <= 8) {
        return text.slice(0, 2) + '****' + text.slice(-2);
      }
      return text.slice(0, 3) + '****' + text.slice(-4);
    },
    reload() {
      this.$refs.table.reload({ where: this.where });
    },
    reset() {
      this.where = {};
      this.reload();
    },
    openEdit(row) {
      this.current = row;
      this.showEdit = true;
    },
    openDetail(row) {
      this.current = row;
      this.detailEdit = true;
    },
    openChannelUser(row, type) {
      this.$refs.channelUserEdit.openMask(row, type);
    },
    openChannelBatch(type) {
      this.$refs.channelBatchEdit.openMask(type);
    },
    openTest(row) {
      this.testUser = row;
      this.showTest = true;
    },
    openBind(row) {
      this.bindUser = row;
      this.showBind = true;
    },
    openIp(row) {
      this.ipUser = row;
      this.showIp = true;
    },
    onMore(cmd, row) {
      if (cmd === 'test') {
        this.openTest(row);
        return;
      }
      if (cmd === 'bind') {
        this.openBind(row);
        return;
      }
      if (cmd === 'ip') {
        this.openIp(row);
        return;
      }
      if (cmd === 'reset') {
        this.openDetail(row);
        return;
      }
      if (cmd === 'remove') {
        this.$confirm('确定要删除此用户吗？', '提示', { type: 'warning' })
          .then(() => this.remove(row))
          .catch(() => {});
      }
    },
    request(url, params) {
      const loading = this.$loading({ lock: true });
      return this.$http
        .post(url, params)
        .then((res) => {
          loading.close();
          if (res.data.code === 0) {
            this.$message.success(res.data.msg);
            return true;
          }
          this.$message.error(res.data.msg);
          return false;
        })
        .catch((e) => {
          loading.close();
          this.$message.error(e.message);
          return false;
        });
    },
    remove(row) {
      this.request('/user/delete', { id: row.id }).then((ok) => {
        if (ok) this.reload();
      });
    },
    removeBatch() {
      if (!this.selection.length) {
        this.$message.error('请选择');
        return;
      }
      this.$confirm('确定要删除选中的用户吗?', '提示', { type: 'warning' })
        .then(() => {
          this.request('/user/delete', {
            id: this.selection.map((d) => d.id)
          }).then((ok) => {
            if (ok) this.reload();
          });
        })
        .catch(() => {});
    },
    editStatus(row) {
      this.request('/user/status', {
        id: row.id,
        status: row.status
      }).then((ok) => {
        if (!ok) row.status = row.status === 1 ? 2 : 1;
      });
    },
    editFlag(row, field) {
      this.request('/user/edit', {
        id: row.id,
        [field]: row[field]
      }).then((ok) => {
        if (!ok) row[field] = row[field] === 1 ? 2 : 1;
      });
    },
    editGoogleToken(row) {
      this.$confirm('确定要解绑谷歌验证吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.request('/user/editGoogle', { id: row.id }).then((ok) => {
            if (ok) row.google_status = 2;
          });
        })
        .catch(() => {});
    }
  }
};
</script>

<style scoped>
.dict-cell-clickable {
  cursor: pointer;
  display: inline-block;
}
</style>
